export default __webpack_public_path__ + "static/media/koun.4f6ce9c4.jpeg";